import React from 'react';
import { Button, Modal } from 'antd';

export interface DashboardTreeCuttingConfirmModalProps {
    theme: string;
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    sceneViewer: unknown;
    reRunningTreeScenarios: boolean;
}

export function DashboardTreeCuttingConfirmModal({
    theme,
    open,
    onCancel,
    onConfirm,
    sceneViewer,
    reRunningTreeScenarios,
}: DashboardTreeCuttingConfirmModalProps) {
    return (
        <Modal
            title="Process tree cutting?"
            open={open}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    loading={reRunningTreeScenarios}
                    disabled={!sceneViewer || reRunningTreeScenarios}
                    onClick={onConfirm}
                >
                    Yes, process tree cutting
                </Button>,
            ]}
            className={`editor-ai-tree-cutting-confirm-modal obd-theme-${theme}`}
            rootClassName={`obd-form-controls-modal-root obd-theme-${theme}`}
            destroyOnHidden
            centered
        >
            <p className="editor-ai-tree-cutting-confirm-modal__text">
                Do you want to process the tree cutting for this design?
            </p>
        </Modal>
    );
}
